import type { QueryClient, Query } from "@tanstack/react-query";

export function isClarityOneMeQuery(query: { queryKey: unknown }): boolean {
  const key = query.queryKey;
  if (!Array.isArray(key) || key.length === 0) return false;
  const head = key[0];
  if (Array.isArray(head)) {
    return head[0] === "clarityOneAuth" && head[1] === "me";
  }
  return head === "clarityOneAuth";
}

/** Abort in-flight Clarity One identity fetches so the global loading bar can release. */
export async function cancelClarityOneMeQueries(queryClient: QueryClient): Promise<void> {
  try {
    await queryClient.cancelQueries({
      predicate: (query: Query) => isClarityOneMeQuery(query),
    });
  } catch {
    // Query.cancel rejects in-flight fetchers with CancelledError.
  }
}

/** Timeout recovery unpauses (one new fetch). Error recovery refetches the settled query. */
export function planClarityOneMeRetry(paused: boolean): "unpause" | "refetch" {
  return paused ? "unpause" : "refetch";
}
